//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import breadCrumbs from '~/components/common/breadCrumbs.vue'
import vueQR from '~/components/common/vueQR.vue'
import { add, assign, cloneDeep, getToday } from '~/assets/js/utils.js'
export default {
  components: {
    'bread-crumbs': breadCrumbs,
    'vue-qr': vueQR
  },
  async asyncData ({ $api, store, params, redirect, error }) {
    const { locale = 'en', countryCode = '840', cookieVal = '', simpleUser = {} } = store.state
    const gId = Number(params?.id?.split('.')[0]) || ''
    if (!gId) return redirect(`/${locale}/eashop.html`) // 浏览器地址栏不存在商品id，跳转回列表页
    try {
      let [userId, myMail] = ['0', ''] // 用户id、邮箱
      if (cookieVal) { // 若用户已登录，获取其用户id
        userId = simpleUser?.userId
        const { result = {} } = await $api.login.getUserInfoServer({ UserId: userId, ApplicationType: 7, CountryCode: countryCode, LanguageCode: locale, Ppl: 7, Poy: 1 })
        myMail = (result?.email || '')
      }
      const { eaList = [], eaDetailInfo = {} } = await $api.holdPosi.eaDetail({ goodsId: gId, num: 5, uid: userId, source: 'pc' })
      const { eaDetail = {}, historyTrend = [], eaStat = {} } = eaDetailInfo || {}
      if (!Object.keys(eaDetail)?.length) return error({ statusCode: 404 }) // 没有数据
      return {
        userId,
        eaList: (eaList?.slice(0, 5) || []),
        info: eaDetail,
        historyTrend,
        eaStat: eaStat || {},
        mailPop: { show: false, myMail, isErr: false, success: false }
      }
    } catch (err) {}
  },
  data () {
    return {
      userId: '', // 用户id
      eaList: [], // EA列表项
      info: { // 页面信息
        GoodsId: '',
        color: '',
        type: '',
        mtColor: '',
        mtName: '',
        name: '',
        isPraise: false,
        dot: 0,
        profit_rate: 0,
        mttype: 0,
        code: '',
        updatetime: getToday(),
        fullPicture: '',
        summary: '',
        priceInfoForSpecificCountry: { symbol: '', price: '', price_original: '' },
        purchaseQuantify: 0,
        description: '',
        isBought: 0,
        reportUrl: '',
        urlForDownload: ''
      },
      hisLine: null, // 图表实例
      historyTrend: [], // 折线图数据
      eaStat: {}, // 高级统计（表格数据）
      advancedList: [ // 高级统计
        { id: '1', name: 'TYY_000028', value: '' },
        { id: '2', name: 'TYY_000029', value: '$' },
        { id: '3', name: 'TYY_000030', value: '$' },
        { id: '4', name: 'TYY_000627', value: '$' },
        { id: '5', name: 'TYY_000032', value: '$' },
        { id: '6', name: 'TYY_000033', value: '' },
        { id: '7', name: 'TYY_000034', value: '' },
        { id: '8', name: 'TYY_000035', value: '' },
        { id: '9', name: 'TYY_000036', value: '' },
        { id: '10', name: 'TYY_000037', value: '' },
        { id: '11', name: 'TYY_000038', value: '' },
        { id: '12', name: 'TYY_000039', value: '' },
        { id: '13', name: 'TYY_000040', value: '$' },
        { id: '14', name: 'TYY_000041', value: '$' },
        { id: '15', name: 'TYY_000042', value: '$' },
        { id: '16', name: 'TYY_000043', value: '$' },
        { id: '17', name: 'TYY_000044', value: '$' },
        { id: '18', name: 'TYY_000045', value: '$' },
        { id: '19', name: 'TYY_000046', value: '' },
        { id: '20', name: 'TYY_000047', value: '' },
        { id: '21', name: 'TYY_000048', value: '' },
        { id: '22', name: 'TYY_000049', value: '' }
      ],
      statisticsArr: [], // 高级统计（用于页面渲染）
      isShowAll: true, // 是否展示高级统计所有数据（移动端）
      isAgree: true, // 是否同意风险协议书
      riskPop: false, // “风险协议书”弹框
      scanPop: false, // “扫码下载”弹框
      readFirstPop: false, // “请先阅读并同意风险协议书”弹框
      cannotPop: false, // “您还未购买该EA，不能下载”弹框
      downPop: false, // “下载EA”弹框
      mailPop: { // “接收邮箱”弹框
        show: false,
        myMail: '', // 用户输入的邮箱
        isErr: false, // 邮箱格式错误
        success: false // 邮件是否发送成功
      }
    }
  },
  head () {
    let describe = (this?.info?.summary || '')
    describe = (describe.length > 30 ? describe.slice(0, 30) + '...' : describe)
    return {
      title: this.$t('19857')?.replace('{0}', this?.info?.type)?.replace('{1}', this?.info?.name),
      meta: [
        { name: 'Keywords', content: `【${this?.info?.name}】${this.$t('TYY_000003')}` },
        { name: 'Description', content: this.$t('19858')?.replace('{0}', this?.info?.type)?.replace('{1}', this?.info?.name)?.replace('{2}', describe) }
      ]
    }
  },
  computed: {
    // 是否为移动端
    isM () {
      return this.$store.state?.isMobile
    },
    // 当前屏幕的宽度
    screenWidth () {
      return this.$store.state?.screenWidth || 0
    },
    // 面包屑导航——首页
    breadHost () {
      return this.$store.getters.breadHome
    },
    // “扫码下载”背景图
    scanBg () {
      return !this.$store.state?.isChina ? 'https://resources.interface003.com/cloud/img/eashop/scan-bg.svg' : 'https://resources.interface003.com/cloud/img/eashop/scan-bg-cn.png'
    },
    // 是否展示长表格样式
    showLongTable () {
      return this.screenWidth < 1000
    },
    // 获取字符串的年月日
    getDay () {
      return (value = '') => getToday(value)
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    screenWidth (newV) {
      this.hisLine?.resize()
    },
    // 监听当前设备是否为移动端
    isM (newV) {
      this.isShowAll = !newV // 移动端默认不展示全部数据，其他端默认展示所有数据
    },
    // 监听是否展示高级统计所有数据（移动端）
    isShowAll (newV) {
      this.statisticsArr = newV ? cloneDeep(this.advancedList) : this.advancedList?.slice(0, 6) // true展示所有数据，false展示前六条数据
    }
  },
  created () {
    this.eaList?.forEach((item) => {
      item.isPraise = false
      item.profit_rate = (item.profit_rate || 0)
      item.purchaseQuantify = (item.purchaseQuantify || 0)
      item.dot = (item.dot || 0)
    })
    this.advancedList?.forEach((item, index) => {
      const key = ['category', 'InitialFunds', 'TotalNetProfit', 'TotalProfit', 'TotalLoss', 'ProfitRatio', 'ExpectedProfit', 'TransactionOrderTotal', 'SalesOrderProfit', 'PayOrderProfit', 'ProfitableTransactionsTotal', 'LossTradingTotal', 'BiggestProfitableTrade', 'BiggestLossMakingTransactions', 'AvProfitableTrade', 'AvLossMakingTransactions', 'BigConProfitAmount', 'BigAmoutConLoss', 'MostNumConProfits', 'MostNumConLoss', 'AvContinuousProfit', 'AvContinuousLoss'][index]
      item.value = item.value + (this.eaStat[key] || '-')
    })
  },
  mounted () {
    this.statisticsArr = this.isM ? this.advancedList?.slice(0, 6) : cloneDeep(this.advancedList)
    this.setHistoryLine(this.historyTrend)
  },
  beforeDestroy () {
    this.hisLine?.clear() // 清空当前实例
    this.hisLine?.dispose() // 销毁图表
    this.hisLine = null
  },
  methods: {
    // 跳转至详情页
    toDetails (value = '') {
      window?.open(`/${this.currLangCode()}/eashop/${value}.html`)
    },
    // 点赞
    async praiseFn (obj = {}) {
      const { GoodsId = '', dot = 0, isPraise = false } = obj
      if (isPraise) return true // 已点赞，不执行后续操作
      assign(obj, { dot: add(dot, 1), isPraise: true })
      await this.$api.holdPosi.eaPraise({ GoodsId })
    },
    // 同意风险协议书
    iKonwFn () {
      this.isAgree = true
      this.riskPop = false // 关闭弹框
    },
    // 打开“下载EA”弹框
    downloadEA (value = 1) {
      const [notBuyPop, isLogin, isBuyEA] = [value != 1, this.$store.state.cookieVal, this?.info?.isBought > 0]
      // 第一步：是否同意风险协议书
      if (!this.isAgree) {
        this.readFirstPop = true
        return false
      }
      // 第二步：用户是否登录
      if (notBuyPop && !isLogin) {
        this.$store.commit('setVal', { loginShow: true })
        return false
      }
      // 第三步：判断用户是否购买EA
      if (notBuyPop && !isBuyEA) {
        this.cannotPop = true
        return false
      }
      switch (value) {
        case 1: // 第一个按钮
          if (this.isM) window?.open(`/${this.currLangCode()}/eashop/download.html?id=${this.info?.GoodsId}`)
          else this.scanPop = true
          break
        case 3: // 第三个按钮
          window?.open(this.info?.urlForDownload)
          break
        case 4: // 第四个按钮
          assign(this.mailPop, { show: true })
          break
      }
    },
    // 输入框失焦
    mailBlurFn () {
      if (!this.mailPop?.myMail?.trim()?.length) return false // 输入框为空
      const isPass = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(this.mailPop?.myMail) // eslint-disable-line
      assign(this.mailPop, { isErr: !isPass })
      return isPass
    },
    // 发送邮箱
    async sendMailFn () {
      if (!this.mailBlurFn()) return false // 校验不通过
      const langCode = (this.currLangCode().includes('-') ? `${this.currLangCode().split('-')[0]}-${this.currLangCode().split('-')[1]?.toUpperCase()}` : this.currLangCode())
      const { myMail = '' } = this.mailPop
      if (!myMail?.trim()?.length) return false // 未输入邮箱，不执行后续操作
      await this.$api.holdPosi.sendMail({ GoodsId: this.info?.GoodsId, UserId: this.userId, Email: myMail, Language: langCode })
      assign(this.mailPop, { success: true })
    },
    // 绘制历史走势折线图
    setHistoryLine (arr = []) {
      if (!arr.length) return false // 没有数据时，不执行后续操作
      this.lineDom = document.getElementsByClassName('history-line')[0]
      this.hisLine = this.$echarts.init(this.lineDom)
      const option = {
        tooltip: {
          trigger: 'axis',
          padding: [12, 16],
          backgroundColor: 'rgba(0,0,0,0.7)',
          borderColor: 'rgba(0,0,0,0.2)',
          formatter: (params = {}) => `<div class="history-chart-pop"><p class="item-value">${params[0]?.value?.toFixed(2)}</p><p class="item-date">${params[0]?.axisValue}</p></div>`
        },
        grid: {
          top: '6%',
          bottom: '2%',
          left: '4%',
          right: '4%',
          containLabel: true
        },
        xAxis: {
          boundaryGap: false,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            fontSize: 12,
            color: '#A3A3A3',
            margin: 20,
            hideOverlap: true,
            formatter: (value = '') => getToday(value)
          },
          axisPointer: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(204,41,68,0.3)'
            }
          },
          data: arr.map(item => item.quotaTime)
        },
        yAxis: {
          axisLabel: {
            fontSize: 12,
            color: '#A3A3A3'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(0,0,0,0.05)'
            }
          },
          scale: true
        },
        series: [{
          type: 'line',
          showSymbol: false,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            color: '#CC2944',
            borderWidth: 4,
            borderColor: 'rgba(204,41,68,0.2)'
          },
          lineStyle: {
            color: '#5C8AE5'
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{ offset: 0, color: 'rgba(92,138,229,0.15)' }, { offset: 1, color: 'rgba(92,138,229,0)' }]
            }
          },
          smooth: true,
          data: arr.map(item => Number(item.balance))
        }]
      }
      this.hisLine?.setOption(option)
    },
    // 邮箱弹框关闭时
    mailCloseFn () {
      assign(this.mailPop, { myMail: '', isErr: false, success: false }) // 恢复初始值
    }
  }
}
